/* ==========================================================================
   VAN LYNN — wishlist.js
   Guest wishlist stored in the shopper's browser (localStorage).
   LIMITATIONS: does not sync across devices/browsers or to customer accounts.
   Install a customer-linked wishlist app for cross-device persistence and
   disable "Enable built-in wishlist" in Theme settings → Wishlist.
   ========================================================================== */
(function () {
  'use strict';
  const KEY = 'vl:wishlist';
  const VL = (window.VL = window.VL || {});

  const store = {
    get() {
      try {
        const list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    },
    set(list) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60)));
        return true;
      } catch (e) {
        return false;
      }
    },
    has(handle) {
      return this.get().includes(handle);
    },
    toggle(handle) {
      const list = this.get();
      const idx = list.indexOf(handle);
      if (idx > -1) list.splice(idx, 1);
      else list.unshift(handle);
      this.set(list);
      return idx === -1;
    },
  };
  VL.wishlist = store;

  function syncButtons(root = document) {
    const list = store.get();
    root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const saved = list.includes(btn.dataset.wishlistToggle);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? btn.dataset.labelRemove : btn.dataset.labelAdd);
      const text = btn.querySelector('.wishlist-toggle__text');
      if (text) text.textContent = saved ? text.dataset.textRemove : text.dataset.textAdd;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const added = store.toggle(btn.dataset.wishlistToggle);
    syncButtons();
    btn.classList.remove('is-pulsing');
    void btn.offsetWidth;
    btn.classList.add('is-pulsing');
    const title = btn.dataset.productTitle || '';
    const msg = (added ? window.theme.strings.wishlistAdded : window.theme.strings.wishlistRemoved).replace('[title]', title);
    VL.toast(msg);
    VL.announce(msg);
    document.dispatchEvent(new CustomEvent('vl:wishlist-change', { detail: { handle: btn.dataset.wishlistToggle, added } }));
  });

  /* Wishlist page grid */
  class WishlistGrid extends HTMLElement {
    connectedCallback() {
      this.render();
      this.onChange = () => this.render();
      document.addEventListener('vl:wishlist-change', this.onChange);
    }
    disconnectedCallback() {
      document.removeEventListener('vl:wishlist-change', this.onChange);
    }
    async render() {
      const grid = this.querySelector('[data-wishlist-grid]');
      const empty = this.querySelector('[data-wishlist-empty]');
      const handles = store.get();
      if (!handles.length) {
        grid.innerHTML = '';
        empty.hidden = false;
        return;
      }
      empty.hidden = true;
      this.setAttribute('aria-busy', 'true');
      const count = await VL.renderProductCards(handles, grid);
      this.removeAttribute('aria-busy');
      if (!count) empty.hidden = false;
      syncButtons(this);
    }
  }
  if (!customElements.get('wishlist-grid')) customElements.define('wishlist-grid', WishlistGrid);

  document.addEventListener('DOMContentLoaded', () => syncButtons());
  document.addEventListener('vl:content-loaded', (e) => syncButtons(e.detail?.root || document));
  document.addEventListener('shopify:section:load', () => syncButtons());
})();
